import React from 'react'
import ReactDOM from 'react-dom'
import { ReactComponent as Success } from './check.svg'
import { ReactComponent as Loading } from 'media/icons/loading.svg'
import { ReactComponent as ErrorIndicator } from 'media/icons/attention.svg'
import { ReactComponent as NoNetworkIndicator } from 'media/icons/nonetwork.svg'
import usePortal from 'hooks/usePortal'

import cn from 'classnames'
import styles from './StatusIndicator.module.scss'

const Indicator = ({ status }) => {
	let icon
	let className = ''
	switch(status) {
		case 'loading':
			icon = <Loading/>
			className = 'loading'
			break
		case 'error':
			icon = <ErrorIndicator/>
			className = 'error'
			break
		case 'networkError':
			icon = <NoNetworkIndicator/>
			className = 'error'
			break
		default:
			icon = <Success/>
			className = 'success'
			break
	}

	const portal = usePortal('root')
	return ReactDOM.createPortal((
		<div className={cn(styles.root, styles[className])}>
			{icon}
		</div>
	), portal)
}

export default Indicator
